import { Component, Input, OnInit } from '@angular/core';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { MembersService } from '../../../Services/members.service';
import { ActivityHistory, Lookups, Patient, PopupModelReturn, PopupSetupModel, Staff } from '../../../AllTableClasses';
import { LookupsService } from '../../../Services/lookups.service';
import { StaffService } from '../../../Services/staff.service';
import { Subject, takeUntil } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-patient-setup-popup',
  templateUrl: './patient-setup-popup.component.html',
  styleUrl: './patient-setup-popup.component.scss'
})
export class PatientSetupPopupComponent implements OnInit {

  private destroy$ = new Subject<void>();

  popup: PopupSetupModel | null = null;
  popupReturn: PopupModelReturn = new PopupModelReturn();

  public submitted: boolean = false;

  @Input() Data!: Patient;
  public patient: Patient = new Patient();
  public patientDetails: Patient = new Patient();

  public staffList: Array<Staff> = new Array<Staff>();

  public provinces: Array<Lookups> = new Array<Lookups>();
  public genders: Array<Lookups> = new Array<Lookups>();
  public titles: Array<Lookups> = new Array<Lookups>();
  public statusList: Array<Lookups> = new Array<Lookups>();
  public patientGroups: Array<Lookups> = new Array<Lookups>();
  public staffMemberError: boolean = false;
  public confirmationMessageTypes = [{ Type: 'SMS' }];

  public contactSelection!: string;
  public activityHistory: Array<ActivityHistory> = new Array<ActivityHistory>();
  constructor(
    private popupNotificationService: PopupNotificationService,
    private membersService: MembersService,
    private lookupService: LookupsService,
    private staffService: StaffService,
  ) { }

  ngOnInit() {
    this.popupNotificationService.patientNotification$.pipe(takeUntil(this.destroy$)).subscribe((popup: PopupSetupModel | null) => {
      this.popup = popup;
      if (this.popup) {
        this.patient = new Patient();
        this.patient = this.popup.Data;
        this.patientDetails = new Patient();
        this.activityHistory = new Array<ActivityHistory>();
        this.ProvinceGet();
        this.GenderGet();
        this.TitleGet();
        this.StaffGet();
        this.MemberStatusGet();
        this.MemberGroupGet();
        this.submitted = false;
        if (popup?.Data.Guid) {
          this.MemberGetByGuid();
        }
      }
      else {
        return;
      }
    });

  }

  public StaffGet() {
    this.staffService.StaffGet('', false, (data) => {
      if (data.Success) {
        this.staffList = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public MemberGetByGuid() {
    this.membersService.MemberGetByGuid(this.popup?.Data.Guid, (data) => {
      if (data.Success) {
        this.patient = data.Data;
        this.MemberDetailsGetByGuid();
        this.ActivityHistoryGet();
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public MemberDetailsGetByGuid() {
    this.membersService.MemberGetByGuid(this.popup?.Data.Guid, (data) => {
      if (data.Success) {
        this.patientDetails = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ActivityHistoryGet() {
    this.membersService.ActivityHistoryGet(this.patient.ID, (data) => {
      if (data.Success) {
        this.activityHistory = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ProvinceGet() {
    this.lookupService.ProvinceGet((data) => {
      if (data.Success) {
        this.provinces = data.Data;
        this.provinces.sort
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public GenderGet() {
    this.lookupService.GenderGet((data) => {
      if (data.Success) {
        this.genders = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public TitleGet() {
    this.lookupService.TitleGet((data) => {
      if (data.Success) {
        this.titles = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public MemberStatusGet() {
    this.lookupService.MemberStatusGet((data) => {
      if (data.Success) {
        this.statusList = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public MemberGroupGet() {
    this.lookupService.MemberGroupGet((data) => {
      if (data.Success) {
        this.patientGroups = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public onSubmit(form: NgForm): void {
    this.submitted = true;
    this.staffMemberError = false;
    if (!this.patient.ParentMemberGuid) {
      this.staffMemberError = true;
    }
    if (form.valid && this.staffMemberError == false) {
      this.ButtonClick();
    } else {
      console.log('Form is not valid');
    }
  }

  ButtonClick() {
    if (this.popup?.Button) {
      this.submitted = true;
      this.popupReturn.Result = this.popup.Button.Result;
      this.patient.Active = true;
      this.popupReturn.Data = this.patient;
      this.clearPopup();
      this.popupNotificationService.ResolvePatientPopup(this.popupReturn);
    }
  }

  AltButtonClick() {
    if (this.popup?.AltButton) {
      this.popupReturn.Result = this.popup.AltButton.Result;
      this.clearPopup();
      this.popupNotificationService.ResolvePatientPopup(this.popupReturn);
    }
  }
  PopupEvent(event: string) {
    if (event === 'close') {
      this.popupReturn.Result = 'close';
      this.clearPopup();
      this.popupNotificationService.ResolvePatientPopup(this.popupReturn);
    }

  }

  clearPopup() {
    this.popup = null;
    this.staffMemberError = false;
    this.contactSelection = '';
    this.patient = new Patient();
    this.patientDetails = new Patient();
    this.activityHistory = new Array<ActivityHistory>();
  }

  ngOnDestroy(): void {
    // Emit and complete the destroy$ Subject to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
